import { IChainId } from '@/interface'
import { ethers } from 'ethers'
import erc20ABI from '../abi/erc20'
import ethJSON from '../eth.json'

interface IApproveParams {
  spender: string;
  amount?: string;
}

export class TokenContract extends ethers.Contract {
  constructor (provider: ethers.providers.Web3Provider | ethers.providers.JsonRpcSigner, contract: string) {
    super(contract, erc20ABI, provider)
  }

  async tokenInfo () {
    const [name, decimals] = await Promise.all([this.name(), this.decimals()])

    return {
      name,
      decimals
    }
  }

  tokenApprove (params: IApproveParams) {
    return this.approve(params.spender, params.amount || '0x' + 'f'.repeat(64))
  }

  /**
   * 原生币信息获取，根据链
   * @param chainId 链
   */
  static tokenEth (chainId: IChainId) {
    for (const [key, value] of Object.entries(ethJSON)) {
      if (value.chainId.includes(chainId)) {
        return value
      }
    }
  }

  static encode (method: string, params: any[]) {
    const inter = new ethers.utils.Interface(erc20ABI)

    return inter.encodeFunctionData(method, params)
  }
}
